import type { IAssetEntry } from '@/types'

/** True for asset-index media kinds that back an on-air `<video>` (blob MP4 or HLS). */
export function isVideoPlaybackMediaKind(kind: string): boolean {
  return kind === 'video-blob' || kind === 'hls'
}

export function assetEntryMediaKind(entry: IAssetEntry | undefined): string {
  if (entry == null) {
    return 'missing'
  }
  if ('isHlsVideo' in entry && entry.isHlsVideo) {
    return 'hls'
  }
  if ('isNativeVideo' in entry && entry.isNativeVideo === true) {
    return 'video-blob'
  }
  if ('isVideoBlob' in entry && entry.isVideoBlob === true) {
    return 'video-blob'
  }
  if ('blob' in entry && entry.blob instanceof Blob) {
    if (entry.blob.type.includes('image')) {
      return 'image'
    }
    if (entry.blob.type.includes('video')) {
      return 'video-blob'
    }
    return `blob:${entry.blob.type || 'unknown'}`
  }
  if ('vnode' in entry && entry.vnode) {
    const t = entry.vnode.type
    if (typeof t === 'object' && t != null && 'name' in t) {
      return `vnode:${String((t as { name?: string }).name)}`
    }
    if (typeof t === 'string') {
      return `vnode:${t}`
    }
    return 'vnode'
  }
  return 'other'
}

export function isPortalTailAssetUrn(assetUrn: string | undefined): boolean {
  return (assetUrn ?? '').includes('portal-black-tail-filler')
}
